import React, { FunctionComponent, useCallback } from 'react'
import Link from 'next/link'
import cn from 'classnames'

import { Icon, IconName } from '@/icons'
import { useMarketingUrl } from '@/hooks/MarketingUrl'

import styles from './NavigationMenuSecondLevelItem.module.scss'

interface NavigationMenuSecondLevelItemProps {
  className?: string
  title: string
  href?: string
  icon?: IconName
  isActive: boolean
  withSubMenu?: boolean
  onShowSubMenu?: (title: string) => void
  onClickLink: () => void
}
export const NavigationMenuSecondLevelItem: FunctionComponent<
  NavigationMenuSecondLevelItemProps
> = ({
  isActive,
  title,
  className,
  href,
  icon,
  withSubMenu,
  onShowSubMenu,
  onClickLink,
}) => {
  const marketingUrl = useMarketingUrl()
  const marketingHref = marketingUrl(href ?? '')

  const showSubMenu = useCallback(() => {
    if (onShowSubMenu != null) {
      onShowSubMenu(title)
    }
  }, [onShowSubMenu, title])

  if (withSubMenu) {
    return (
      <button
        className={cn(styles.container, styles.withSubMenu, className, {
          [styles.isActive]: isActive,
        })}
        onClick={showSubMenu}
      >
        {icon != null ? <Icon name={icon} className={styles.icon} /> : null}
        {title}
        {/* <div className={styles.iconChevronContainer}> */}
        <Icon name="chevron" className={cn(styles.iconChevron)} />
        {/* </div> */}
      </button>
    )
  }

  if (href == null) {
    return null
  }

  return (
    <>
      <Link
        onClick={onClickLink}
        className={cn(styles.container, className)}
        href={marketingHref}
      >
        {icon != null ? <Icon name={icon} className={styles.icon} /> : null}
        {title}
        <div className={styles.iconChevronContainer}>
          <Icon name="chevron" className={cn(styles.iconChevron)} />
        </div>
      </Link>{' '}
    </>
  )
}
